import { useEffect, useState } from "react";
import AdminShell, { AGENT_NAV } from "../components/admin/AdminShell";
import LoginView from "../components/admin/LoginView";
import ChangePasswordView from "../components/admin/ChangePasswordView";
import DashboardView from "../components/admin/DashboardView";
import PipelineView from "../components/admin/PipelineView";
import RecruitsView from "../components/admin/RecruitsView";
import RecruitDrawer from "../components/admin/RecruitDrawer";
import NotificationsSheet, { PushBanner, usePush } from "../components/admin/NotificationsSheet";
import useCrm from "../components/admin/useCrm";
import { useLeadDeepLink } from "../components/admin/useLeadDeepLink";

export default function AgentPage() {
  const crm = useCrm({ tokenKey: "breeze_agent_token", role: "agent" });
  const [view, setView] = useState("dashboard");
  const [selectedId, setSelectedId] = useState(null);
  const [pwOpen, setPwOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const { leads, stats, user } = crm;
  const ready = !!crm.token && !!user && !user.must_change_password;
  const push = usePush(crm.api, ready);
  useLeadDeepLink(leads, setSelectedId);

  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (!link) return;
    const prev = link.href;
    link.href = "/manifest-agent.json";
    return () => { link.href = prev; };
  }, []);

  if (!crm.token) return <LoginView onLogin={crm.login} variant="agent" />;
  if (user?.must_change_password) return <ChangePasswordView forced onSubmit={crm.changePassword} onLogout={crm.logout} userName={user.name} />;

  const selected = leads.find((l) => l.id === selectedId) || null;
  const counts = { pipeline: leads.filter((l) => !["Onboarded", "Lost"].includes(l.status)).length, recruits: leads.length };
  const newCount = leads.filter((l) => l.status === "New").length;

  return (
    <AdminShell nav={AGENT_NAV} brandLabel="Agent Portal" view={view} setView={setView} counts={counts} user={user} loading={crm.loading}
      onRefresh={crm.load} onLogout={crm.logout} onChangePassword={() => setPwOpen(true)} onNotifications={() => setNotifOpen(true)} pushOn={push.subscribed} newCount={newCount}>
      {view === "dashboard" && (
        <div className="space-y-4">
          <PushBanner push={push} onOpen={() => setNotifOpen(true)} />
          <DashboardView stats={stats} leads={leads} onOpen={setSelectedId} goTo={setView} agentMode userName={user?.name} />
        </div>
      )}
      {view === "pipeline" && <PipelineView leads={leads} onMove={crm.setStage} onOpen={setSelectedId} />}
      {view === "recruits" && <RecruitsView leads={leads} agents={[]} onOpen={setSelectedId} onStage={crm.setStage} agentMode />}
      <RecruitDrawer lead={selected} agents={[]} canManage={false} onClose={() => setSelectedId(null)} onStage={crm.setStage} onLoadEmails={crm.getEmails}
        onAddNote={crm.addNote} onDeleteNote={crm.deleteNote} />
      {pwOpen && <ChangePasswordView onSubmit={crm.changePassword} onClose={() => setPwOpen(false)} />}
      {notifOpen && <NotificationsSheet push={push} role="agent" onClose={() => setNotifOpen(false)} />}
    </AdminShell>
  );
}
